import { URLPattern } from 'urlpattern-polyfill'
import { CreateHistory } from 'rutter'

import { AuthQueryParams } from '$constants/auth'
import { ProfilePageQueryParams } from '$constants/profile'

export const {
  on,
  onOneOf,
  redirect,
  routeState,
  summaryState,
  watchRouteState,
  watchSummaryState,
  getDetail
} = new CreateHistory({
  URLPattern,
  routes: {
    root: {
      pathname: '/'
    },

    applications: {
      pathname: '/applications',
      meta: {
        title: 'Applications'
      }
    },
    profileDetail: {
      pathname: '/profile',
      meta: {
        title: 'Profile'
      }
    },

    security: {
      pathname: '/security',
      ignore: true,
      meta: {
        title: 'Security'
      }
    },
    securityMfa: {
      pathname: '/security/mfa',
      meta: {
        title: 'Two-Factor Authentication'
      }
    },
    securityPassword: {
      pathname: '/security/password',
      meta: {
        title: 'Password Setting'
      }
    },
    securityLoginHistory: {
      pathname: '/security/login-history',
      meta: {
        title: 'Login History'
      }
    },

    auth: {
      pathname: '/auth',
      ignore: true,
      meta: {
        title: 'Authentication'
      }
    },
    authLogin: {
      pathname: '/auth/login',
      meta: {
        title: 'Login'
      }
    },
    authEmailVerification: {
      pathname: '/auth/email-verification',
      meta: {
        title: 'Email Verification'
      }
    },
    authForgotPassword: {
      pathname: '/auth/forgot-password',
      meta: {
        title: 'Forgot Password'
      }
    },
    authResetPassword: {
      pathname: '/auth/reset-password',
      meta: {
        title: 'Reset Password'
      }
    },
    authSmsOtpVerify: {
      pathname: '/auth/sms-otp/verify',
      meta: {
        title: 'Verify OTP'
      }
    },
    authAccounts: {
      pathname: '/auth/accounts',
      meta: {
        title: 'Accounts'
      }
    },
    authApp: {
      pathname: '/auth/app',
      meta: {
        title: 'Authorize Application'
      }
    },
    authLoginAttentions: {
      pathname: '/auth/login-attentions',
      meta: {
        title: 'Login Attentions'
      }
    },
    authInvalidAccess: {
      pathname: '/auth/invalid-access',
      meta: {
        title: 'Invalid Access'
      }
    },
    aboutPrivacy: {
      pathname: '/about/privacy-policy',
      meta: {
        title: 'Privacy Policy'
      }
    }
  }
})

export type RouteNames = Exclude<typeof routeState.name, undefined>

type AnyQueryParams = Partial<Record<string, string>>

type AnyPageQueryParams = Partial<{
  /** @see {@link AnyPageQueryParams} for more context. */
  block_action: 'ChangePhoneBlock' | 'ChangeEmailBlock'

  device_id: string
}>

export type ExtendedQueryParams = {
  return_to?: RouteNames
} & AuthQueryParams &
  AnyPageQueryParams &
  ProfilePageQueryParams &
  AnyQueryParams
